import { apiClient } from "../config";

async function archiveOrRestoreForm(id: string, status: any) {
  const res = await apiClient.put(`/admin/dynamic-forms/${id}/archive`, null, {
    params: {
      status: status,
    },
  });
  return res.data;
}

export default archiveOrRestoreForm;
